module.exports = ['$urlRouterProvider', '$stateProvider', ($urlRouterProvider, $stateProvider) => {
  $stateProvider
    .state('hospital_booking', {
      insecure: true,
      abstract: true,
      url: '/hospital_booking',
      parent: 'root',
      views: {
        '@': {
          template: `
                <section class="box-layout">
                  <div ui-view="content"></div>
                </section>
            `,
        },
      },
    })
    .state('hospital_booking.action_feedback', {
      insecure: true,
      allowNoGroupId: true,
      url: '/action_feedback?action&logo_group_id',
      views: {
        'content@hospital_booking': {
          template: '<action-feedback></action-feedback>',
        },
      },
    })
    // This URL (along with its parameters) is a bit cryptic, as we needed a tiny URL in order to save us
    // some money when sending SMS communications (which contains this link).
    // "t" parameter stands for "action token", and "ca" stands for "choose action"
    .state('hospital_booking.execute_action', {
      insecure: true,
      allowNoGroupId: true,
      url: '^/ca?t&locale',
      views: {
        'content@hospital_booking': {
          template: '<execute-action></execute-action>',
        },
      },
    });
}];



// WEBPACK FOOTER //
// ./hospital-booking/config/routes.js